const DateConstants = {
  earliestPerformanceDateForCategorisation: '2022-04-01',
  earliestPerformanceDateWithTransactions: '2017-03-25',
};

export default DateConstants;
